import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useEffect } from 'react';
import { useStateValue } from './StateProviders';
import { useNavigate } from 'react-router-dom';
import CustomerLogin from '../portals/customer/CustomerLogin'
import CustomerDetailsRegister from '../portals/customer/CustomerDetailsRegister';
import Homepage from './Homepage/Homepage';
import Headernew from './Headernew';
import Topbar from './Topbar';
import Breadcrumb from './Breadcrumb';
import CustomerSidebar from '../portals/customer/CustomerSidebar';
import { tryOpenAndroidAppForCurrentPath } from '../utils/openMobileApp';


export default function HomeLayout() {
  let navigate = useNavigate()
  const [{ IsLogin, IsRegister }, dispatch] = useStateValue();
  useEffect(() => {
    tryOpenAndroidAppForCurrentPath();
  }, []);

  useEffect(() => {

    console.log(IsRegister)
    if (localStorage.getItem('DToken') !== null && localStorage.getItem("LoginDetails") === 'User') {
      dispatch({ type: 'Login' });
    }
    else {
      dispatch({ type: 'Logout' });
    }


  }, [])
  return (<>
    <Topbar />
    <Header />

    {
      window.location.pathname === '/' ||
        window.location.pathname === '/contact' ||
        window.location.pathname === '/aboutus'


        ?
        <Outlet />
        :
        !IsLogin ?
          <CustomerLogin /> :
          !IsRegister ?
            <CustomerDetailsRegister /> :
            <>
              <Breadcrumb />
              <div className='slidebar_and_component'>
                <CustomerSidebar />
                <div className='outlet_main_div'>
                  <Outlet />
                </div>
              </div>
            </>
    }

    <Footer />
  </>
  )
} 